import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Map from './Map'; // Assuming you have a HomePage component
import About from './About'; // Assuming you have an AboutPage component

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Map />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default App;